// extracted by mini-css-extract-plugin
module.exports = {"root":"Title_root__1A3oI"};